import { idtype } from "querypieces";

export default `
  ...on pageBuilder_video_BlockType {
    ${idtype}
    youtubeLink
  }
`;
